import { GameState } from '../objects/GameState';
import { TiledGameObject } from 'src/games/shared/phaserHelpers/HandyTypes';
import { Color } from 'src/games/shared/ColorValue';
import { Helpers } from '../objects/Helpers';
import initializeInteractiveCursor from 'src/games/shared/InteractiveCursorUtil';
import TranslateApi from 'src/utils/TranslateHelper';

export class DrawBloodScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    background: Phaser.GameObjects.Image;
    map: Phaser.Tilemaps.Tilemap;
    syringe: Phaser.GameObjects.Image;

    constructor() {
        super({
            key: "DrawBloodScene_" + Math.random(),
        });
    }

    preload(): void {
        // All assets were loaded in MainScene
        this.load.tilemapTiledJSON("draw_blood_scene_map", require("/src/assets/qci/maps/labDiagnosisGame/lab_diagnosis_draw_blood_scene.json"));
    }

    create(): void {
        this.initialize();
        this.generateScene();
        initializeInteractiveCursor(this);
    }

    initialize() {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'draw_blood_scene_map' });
    }

    generateScene() {
        let background = this.add.image(this.gameWidth / 2, this.gameHeight / 2, "background");
        background.setDisplaySize(this.gameWidth, this.gameHeight);
        background.setOrigin(0.5);

        this.addObjects();
    }

    addObjects(): void {
        var syringe;
        var translateString = "Diagnosis.Phaser.DrawBloodScene.";
        this.map.getObjectLayer("Scene").objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "alien") {
                var alien = this.add.image(ob.x, ob.y, "assets", "sleb_sick");
                alien.setOrigin(0);
                alien.setDisplaySize(ob.width, ob.height);
                alien.setDepth(3);
            }
            else if (ob.name === "text") {
                var title_fontStyle = { fontFamily: 'Russo One, Roboto Mono, Arial', fontSize: 20, color: '#ffffff', padding: 20, backgroundColor: "#000000" };
                var text = TranslateApi.translate(translateString + "text");
                var box = this.add.text(ob.x, ob.y, text, title_fontStyle).setWordWrapWidth(ob.width, true).setDepth(1);
                box.setX(this.gameWidth / 2 - box.displayWidth / 2);
                this.add.image(box.x - 5, box.y - 5, "pixel").setDisplaySize(box.displayWidth + 10, box.displayHeight + 10).setDepth(.5).setOrigin(0).setTint(0x0033cc);
            }
            else if (ob.name === "syringe") {
                this.syringe = this.add.image(ob.x, ob.y, "assets", "syringe_empty");
                this.syringe.setOrigin(0);
                this.syringe.setDisplaySize(ob.width, ob.height);
                this.syringe.setInteractive();
                var radians = this.toRadians(ob.rotation);
                this.syringe.setRotation(radians);

                Helpers.flashObject(this, this.syringe);
            }
        });

        this.syringe.on('pointerdown', () => {
            this.syringe.setAlpha(1);
            this.syringe.disableInteractive();
            this.tweens.killTweensOf(this.syringe);
            this.takeBloodSample();
        });
    }

    /**
    * Simulates drop of "blood" coming out of eyedropper into beaker
   */
    takeBloodSample(): void {
        this.map.getObjectLayer("Scene").objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "blood") {
                var blood = this.add.image(ob.x, ob.y, "assets", "syringe_liquid");
                blood.setOrigin(0);
                blood.setDisplaySize(ob.width, 0);
                blood.setFlipY(true);
                blood.setDepth(20);
                blood.setRotation(this.syringe.rotation);
                blood.setTint(Color.COLORS.get("alien_blood"));

                this.tweens.add({
                    targets: blood,
                    duration: 2000,
                    x: this.syringe.x + 35,
                    y: {
                        value: this.syringe.y - 3,
                    },
                    ease: "Stepped",
                    easeParams: [1000],
                    displayHeight: {
                        value: 175,
                    },
                    onComplete: () => {
                        Helpers.addNextButton(this);
                    }
                });
            }
        });
    }

    toRadians(degrees: number): number {
        return degrees * (Math.PI / 180);
    }
}



// WEBPACK FOOTER //
// ./src/games/DiagnosisGame/scenes/DrawBloodScene.ts